export default __webpack_public_path__ + "static/media/rnr-sports-table-14.cfc36e8e.webp";